module.exports = __webpack_public_path__ + "img/pin_blue_small.3d8e62d2.svg";